var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{directives:[{name:"tooltip",rawName:"v-tooltip"}],staticClass:"btn btn-transparent btn-clipboard",attrs:{"type":"button","title":_vm.title,"data-clipboard-text":_vm.text,"data-container":_vm.tooltipContainer,"data-placement":_vm.tooltipPlacement}},[_c('i',{staticClass:"fa fa-clipboard",attrs:{"aria-hidden":"true"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// /opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7247add4","hasScoped":false,"buble":{"transforms":{}}}!/opt/gitlab/embedded/service/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./vue_shared/components/clipboard_button.vue
// module id = null
// module chunks = 